import styled from "@emotion/styled";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MUISelect, { type SelectProps as MUISelectProps } from "@mui/material/Select";
import React, { forwardRef, type ReactNode } from "react";

import { Colors } from "../../constants/Colors";

export interface SelectProps extends Omit<MUISelectProps, "children"> {
  helperText?: string;
  children?: ReactNode;
  withFormControl?: boolean;
}

const StyledSelect = styled(MUISelect)`
  &.MuiInputBase-root {
    height: 36px;
    background-color: ${Colors.White};

    & .MuiSelect-select {
      padding: 0 32px 0 14px;
      height: 36px;
      display: flex;
      align-items: center;
    }
  }

  & .MuiOutlinedInput-notchedOutline {
    border-color: ${Colors.Border.main};
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${Colors.Secondary.main};
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${Colors.Secondary.main};
    border-width: 2px;
  }

  &.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: ${Colors.Error.main};
  }
`;

const Select = forwardRef<HTMLDivElement, SelectProps>(
  ({ label, error, helperText, fullWidth = false, withFormControl = false, children, ...props }, ref) => {
    const labelId = props.id ? `${props.id}-label` : undefined;

    // FormControl付きの場合
    if (withFormControl || label || helperText) {
      return (
        <FormControl fullWidth={fullWidth} error={error}>
          {label && <InputLabel id={labelId}>{label}</InputLabel>}
          <StyledSelect {...props} ref={ref} label={label} labelId={labelId}>
            {children}
          </StyledSelect>
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      );
    }

    // 通常のSelect
    return (
      <StyledSelect {...props} ref={ref} error={error}>
        {children}
      </StyledSelect>
    );
  }
);

Select.displayName = "Select";
export default Select;
